var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
    'bg-gray-300 animate-pulse-light': !_vm.showContent
  }, _obj[_vm.skelClass] = !_vm.showContent, _obj[_vm.commonClass] = _vm.showContent, _obj )},[(_vm.showContent)?_vm._t("default"):_c('span',[_vm._v("​")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }